import * as Stimulus from "@hotwired/stimulus"

export class InfoDisplayController extends Stimulus.Controller {
    static classes = [ 'selectedRecord', 'inflateInfoPane' ];
    static targets = [ 'dataRecord', 'hideInfo', 'infoPane', 'infoDisplay', 'infoScroll' ];
    static values = {
        viewRecordQueryParam: { type: String, default: 'v' },
    }

    connect() {
        let queryParams = new URLSearchParams(window.location.search);
        let openRecordId = queryParams.get(this.viewRecordQueryParamValue);
        if(openRecordId == null) { return; }

        let $record = document.querySelector(`[data-err-id="${openRecordId}"]`)
        if($record != undefined) {
            this.displayInfoForRecord($record);
        }
    }

    openInfo(e) {
        if (this.isLinkTag(e) || this.isFormSubmit(e)) { return; }

        this.clearSelected();
        var $record = e.target.closest('div[data-info-id]');
        this.displayInfoForRecord($record);

    }

    displayInfoForRecord($record) {

        let errorId = $record.dataset['errId']
        this.setUrlRecordId(errorId);
        this.infoDisplayTarget.innerHTML = $record.querySelector(`#${$record.dataset['infoId']}`).innerHTML;
        this.infoPaneTarget.classList.add(...this.inflateInfoPaneClasses);
        $record.classList.add(...this.selectedRecordClasses);
        this.infoPaneTarget.classList.remove('hidden');
        this.infoScrollTarget.scrollIntoView({block: "nearest", behavior: "smooth"});

    }

    closeInfo() {
        this.infoDisplayTarget.innerHTML = '';
        this.infoPaneTarget.classList.add('hidden');
        this.clearSelected();
    }

    clearSelected() {
        this.dataRecordTargets.forEach(($e) => {
            $e.classList.remove(...this.selectedRecordClasses);
        });
        this.setUrlRecordId();

    }

    isLinkTag(e) {
        return e.target.nodeName === 'A' && e.target.href != undefined;
    }
    isFormSubmit(e) {
        return e.target.closest('button') != undefined && e.target.closest('form') != undefined;
    }

    setUrlRecordId(recordId) {
        const urlWithPath =`${window.location.origin}${window.location.pathname}`
        var queryParams = new URLSearchParams(window.location.search)
        var newUrl = ''
        if(recordId == null || recordId.length == 0) {
            queryParams.delete(this.viewRecordQueryParamValue);
        } else {
            queryParams.delete(this.viewRecordQueryParamValue);
            queryParams.append(this.viewRecordQueryParamValue, recordId);
        }
        var newUrl = `${urlWithPath}?${queryParams.toString()}${window.location.hash}`

        history.replaceState(null, null, newUrl);
    }
}
